var render = function render(_c,_vm){return _c('v-list-item',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass]},'v-list-item',_vm.data.attrs,false),_vm.data.on),[_c('v-list-item-title',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }